import { ehStatusEquipamento, type StatusEquipamento } from '@/lib/dominio';
import { termoDaBusca } from '@/lib/texto';

/**
 * O estado da lista vive na URL (p.16).
 *
 * O motivo e de uso, nao de arquitetura: "olha a frota parada agora" precisa
 * ser um link que se manda no WhatsApp, e nao uma sequencia de cliques que o
 * outro tem que repetir. Filtro salvo nos favoritos tambem so funciona assim.
 *
 * Os quatro campos sao OPCIONAIS de proposito. Assim a URL so carrega o que o
 * usuario de fato mudou: `/equipamentos` continua `/equipamentos`, e nao vira
 * `/equipamentos?pagina=1&porPagina=10`, que nao diz nada a quem le.
 */
/**
 * O que o campo de busca ANUNCIA, e por isso tambem o que ele olha.
 *
 * Uma constante so, usada pela barra de filtros da pagina E pela busca da barra
 * superior — as duas escrevem no mesmo `?termo=`, e duas portas para o mesmo
 * filtro prometendo listas diferentes fazem quem busca "Vale Verde" no topo
 * achar resultado que o proprio campo dizia nao procurar.
 *
 * A ordem e a mesma em que a pagina monta a lista de campos.
 */
export const CAMPOS_DA_BUSCA = 'Código, código interno, tipo, modelo, fabricante, cliente ou obra';

/**
 * O texto de exemplo DENTRO do campo. A lista inteira nao cabia: a 390 px, e
 * a 1024 na barra superior, saia cortada no meio da palavra ("…cliente ou
 * obr"). O exemplo e curto para caber em caixa alta num campo de 390 px; a
 * lista inteira, `CAMPOS_DA_BUSCA`, vai no `title` do campo.
 */
export const EXEMPLO_DA_BUSCA = 'Código, modelo ou obra';

export interface BuscaEquipamentos {
  readonly termo?: string;
  readonly status?: StatusEquipamento;
  readonly pagina?: number;
  readonly porPagina?: number;
}

export const PADRAO_POR_PAGINA = 10;
export const OPCOES_POR_PAGINA = [10, 25, 50, 100];

/**
 * A URL e entrada do usuario: qualquer coisa pode chegar ali, inclusive
 * colada a mao. Valor fora do vocabulario oficial e DESCARTADO, nunca
 * corrigido no chute — adivinhar o que a pessoa quis dizer e como uma lista
 * passa a mostrar coisa diferente do que o filtro diz.
 */
export function validarBusca(entrada: Record<string, unknown>): BuscaEquipamentos {
  const termo = entrada['termo'];
  const status = entrada['status'];
  const pagina = Number(entrada['pagina']);
  const porPagina = Number(entrada['porPagina']);

  const termoLimpo = termoDaBusca(termo);

  return {
    ...(termoLimpo ? { termo: termoLimpo } : {}),
    ...(ehStatusEquipamento(status) ? { status } : {}),
    ...(Number.isInteger(pagina) && pagina > 1 ? { pagina } : {}),
    ...(OPCOES_POR_PAGINA.includes(porPagina) && porPagina !== PADRAO_POR_PAGINA
      ? { porPagina }
      : {}),
  };
}

/** Monta a busca para navegar, deixando de fora tudo que ja e o padrao. */
export function montarBusca(estado: {
  readonly termo: string;
  readonly status: StatusEquipamento | undefined;
  readonly pagina: number;
  readonly porPagina: number;
}): BuscaEquipamentos {
  const termo = termoDaBusca(estado.termo);

  return {
    ...(termo ? { termo } : {}),
    ...(estado.status ? { status: estado.status } : {}),
    ...(estado.pagina > 1 ? { pagina: estado.pagina } : {}),
    ...(estado.porPagina !== PADRAO_POR_PAGINA ? { porPagina: estado.porPagina } : {}),
  };
}
